export default [
  '/settings',
  '/network_activation'
]
